module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coordinator-element"
  }, [_c('a', {
    staticClass: "coordinator-element__img-container",
    attrs: {
      "href": _vm.item.url,
      "title": _vm.item.description
    }
  }, [_c('img', {
    staticClass: "picture",
    attrs: {
      "src": _vm.item.image || '/public/images/footer/logo/blankIcon.png'
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd3fe270","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/footer/coordinators/element/CoordinatorElement.vue
// module id = d13a5b1a9e6ac1a5d73b
// module chunks = 0